import { Injectable } from "@angular/core";
import { ITokenStorage, MOBILE_TOKEN_KEY } from "./token-storage.interface";

@Injectable()
export class WebTokenStorage implements ITokenStorage {
  async get(): Promise<string | null> {
    return localStorage.getItem(MOBILE_TOKEN_KEY);
  }

  async set(token: string): Promise<void> {
    localStorage.setItem(MOBILE_TOKEN_KEY, token);
  }

  async clear(): Promise<void> {
    localStorage.removeItem(MOBILE_TOKEN_KEY);
  }
}
